import { createContext, useContext, useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";

/**
 * Libraries requested on the Maps JS script tag.
 *   places — address autocomplete, nearby search (pre-existing, do not drop).
 *   marker — google.maps.marker.AdvancedMarkerElement, used by the rider fleet map.
 * One script tag serves the whole dashboard, so anything added here loads for
 * every screen. Keep the list short.
 */
const GOOGLE_MAPS_LIBRARIES = "places,marker";

/**
 * Cloud Map ID. AdvancedMarkerElement REFUSES to render on a map created
 * without one, so the rider fleet map checks this before drawing markers.
 * Create it at Google Cloud console > Google Maps Platform > Map Management,
 * then, because CRA bakes REACT_APP_* in at BUILD time, set it BEFORE building:
 *   heroku config:set REACT_APP_GOOGLE_MAPS_MAP_ID=<id> --app <your-app>
 * A Map ID is not a secret; it is safe in the bundle.
 */
export const GOOGLE_MAPS_MAP_ID = (
  process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || ""
).trim();

const GoogleMapsContext = createContext();

export const useGoogleMaps = () => {
  return useContext(GoogleMapsContext);
};

export const GoogleMapsProvider = ({ children }) => {
  const [mapsApiLoaded, setMapsApiLoaded] = useState(false);
  const [loading, setLoading] = useState(true); // Corrected line

  window.initGoogleMaps = () => {
    setMapsApiLoaded(true);
    setLoading(false);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=${GOOGLE_MAPS_LIBRARIES}&loading=async&callback=initGoogleMaps`;

    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (loading)
    return (
      <div>
        <Spinner
          style={{
            marginTop: "70px",
            top: "50%",
            left: "50%",
            position: "fixed",
          }}
          animation="grow"
          size="lg"
          variant="danger"
        />
      </div>
    );
  return (
    <GoogleMapsContext.Provider value={{ mapsApiLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};
